import getSafeBodyFromHTML from 'draft-js/lib/getSafeBodyFromHTML';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var blockTypes = {
  'H1': 'header-one',
  'H2': 'header-two',
  'H3': 'header-three',
  'H4': 'header-four',
  'H5': 'header-five',
  'H6': 'header-six',
  'LI': 'unordered-list-item',
  'BLOCKQUOTE': 'blockquote',
  'PRE': 'code-block',
  'P': 'unstyled'
};

var isTwitterEmoji = function isTwitterEmoji(element) {
  return element.nodeName === 'IMG' && element.className === 'Emoji Emoji--forText';
};

var isPaperEmoji = function isPaperEmoji(element) {
  return element.nodeName === 'IMG' && element.dataset && element.dataset.hasOwnProperty('emojiCh');
};

var countParents = function countParents(el, match) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (el.parentElement != null) {
    if (match(el.parentElement)) count++;
    return countParents(el.parentElement, match, count);
  } else {
    return count;
  }
};

var textDecorations = {
  underline: 'UNDERLINE',
  'line-through': 'STRIKETHROUGH'
};
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var inlineStyleTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var RawDraftContent = function RawDraftContent(options) {
  var _this = this;

  _classCallCheck(this, RawDraftContent);

  _defineProperty(this, "entityKey", void 0);

  _defineProperty(this, "content", void 0);

  _defineProperty(this, "addText", function (text) {
    var lastBlock = _this.content.blocks[_this.content.blocks.length - 1];

    if (lastBlock.text == null) {
      lastBlock.text = '';
    }

    lastBlock.text += text;
    _this.offset += text.length;
  });

  _defineProperty(this, "addBlock", function (_ref) {
    var entity = _ref.entity,
        block = _objectWithoutProperties(_ref, ["entity"]);

    if (block.type === 'atomic') {
      block.text = ' ';
    } else if (block.text == null) {
      block.text = '';
    }

    if (entity != null) {
      if (block.entityRanges == null) {
        block.entityRanges = [];
      }

      block.entityRanges.push({
        offset: 0,
        length: 1,
        key: _this.addEntity(entity)
      });
    }

    var index = _this.content.blocks.push(block);

    _this.offset = 0;
    return _this.content.blocks[index - 1];
  });

  _defineProperty(this, "addEntity", function (entity) {
    var key = _this.entityKey;
    _this.content.entityMap[key.toString()] = entity;
    _this.entityKey += 1;
    return key.toString();
  });

  _defineProperty(this, "parseTextFragment", function (element) {
    var textFragment = {};
    var inlineStyle = inlineStyleTags[element.nodeName.toLowerCase()];
    var fontWeight = element.style && element.style.fontWeight;
    var textDecoration = element.style && element.style.textDecoration;
    var fontStyle = element.style && element.style.fontStyle;
    var fontFamily = element.style && element.style.fontFamily;
    var inlineStyleRanges = [];

    if (inlineStyle != null) {
      inlineStyleRanges.push(inlineStyle);
    }

    if (boldValues.includes(fontWeight)) {
      inlineStyleRanges.push('BOLD');
    }

    if (fontStyle === 'italic') {
      inlineStyleRanges.push('ITALIC');
    }

    if (textDecorations[textDecoration] != null) {
      inlineStyleRanges.push(textDecorations[textDecoration]);
    }

    if (fontFamily === 'monospace') {
      inlineStyleRanges.push('CODE');
    }

    textFragment = _objectSpread({}, textFragment, {
      inlineStyleRanges: inlineStyleRanges
    });

    if (element.nodeName === 'A' && element.attributes.href != null) {
      textFragment = _objectSpread({}, textFragment, {
        entity: {
          type: 'LINK',
          mutability: 'MUTABLE',
          data: {
            url: element.getAttribute('href'),
            alt: element.getAttribute('rel'),
            title: element.getAttribute('title')
          }
        }
      });
    }

    if (_this.customParseTextFragment != null) {
      var parsedTextFragment = _this.customParseTextFragment(element);

      if (parsedTextFragment != null) {
        textFragment = _objectSpread({}, textFragment, {
          parsedTextFragment: parsedTextFragment,
          inlineStyleRanges: _toConsumableArray(textFragment.inlineStyleRnages).concat(_toConsumableArray(parsedTextFragment.inlineStyleRanges))
        });
      }
    }

    return textFragment;
  });

  _defineProperty(this, "parseBlock", function (element) {
    var blockType = blockTypes[element.nodeName];
    var lastBlock = _this.content.blocks[_this.content.blocks.length - 1];
    var block = {}; // Some editors use DIV instead of P nodes, this will prevent bunching all text into
    // one unstyled block

    if (element.nodeName === 'DIV' && lastBlock && lastBlock.text.length > 0) {
      _this.addBlock({
        type: 'unstyled'
      });
    } // This is for paper code blocks


    if (element.nodeName === 'CODE' && element.parentElement.textContent.length === element.textContent.length) {
      blockType = 'code-block';
    }

    if (element.parentElement.nodeName === 'LI') {
      return null;
    }

    if (element.nodeName === 'LI' && element.parentNode.nodeName === 'OL') {
      blockType = 'ordered-list-item';
    }

    if (element.nodeName === 'LI') {
      var depth = countParents(element, function (el) {
        return ['UL', 'OL'].includes(el.nodeName);
      }) - 1;
      block = {
        depth: depth > 0 ? depth : 0
      };
    }

    if (isTwitterEmoji(element)) {
      _this.addText(element.getAttribute('alt'));
    } else if (isPaperEmoji(element)) {
      _this.addText(element.dataset.emojiCh);
    } else if (element.nodeName === 'IMG') {
      block = {
        type: 'atomic',
        entity: {
          type: 'IMAGE',
          mutability: 'IMMUTABLE',
          data: {
            src: element.getAttribute('src'),
            alt: element.getAttribute('alt')
          }
        }
      };
    }

    if (blockType != null) block = _objectSpread({}, block, {
      type: blockType
    });

    if (_this.customParseBlock != null) {
      var parsedBlock = _this.customParseBlock(element);

      if (parsedBlock != null) {
        block = _objectSpread({}, block, parsedBlock);
      }
    }

    if (Object.keys(block).length === 0) {
      return null;
    }

    return block;
  });

  _defineProperty(this, "addInlineStyleRanges", function (inlineStyleRanges) {
    var lastBlock = _this.content.blocks[_this.content.blocks.length - 1];

    if (lastBlock.inlineStyleRanges == null) {
      lastBlock.inlineStyleRanges = [];
    }

    lastBlock.inlineStyleRanges = lastBlock.inlineStyleRanges.concat(inlineStyleRanges);
  });

  _defineProperty(this, "addEntityRange", function (entity) {
    var lastBlock = _this.content.blocks[_this.content.blocks.length - 1];

    if (lastBlock.entityRanges == null) {
      lastBlock.entityRanges = [];
    }

    lastBlock.entityRanges.push(entity);
  });

  _defineProperty(this, "traverseChildren", function (node) {
    Array.from(node.childNodes).forEach(function (element) {
      var parsedBlock = _this.parseBlock(element);

      var parsedTextFragment = _this.parseTextFragment(element);

      if (parsedBlock) {
        _this.addBlock(parsedBlock);
      } else if (element.nodeName === '#text' && element.textContent != null) {
        _this.addText(element.textContent);
      } else if (parsedTextFragment) {
        if (parsedTextFragment.inlineStyleRanges != null) {
          _this.addInlineStyleRanges(parsedTextFragment.inlineStyleRanges.map(function (style) {
            return {
              style: style,
              offset: _this.offset,
              length: element.textContent.length
            };
          }));
        }

        if (parsedTextFragment.entity != null) {
          _this.addEntityRange({
            key: _this.addEntity(parsedTextFragment.entity),
            offset: _this.offset,
            length: element.textContent.length
          });
        }
      }

      if (element.childNodes != null && (parsedBlock == null || parsedBlock.type !== 'atomic')) {
        _this.traverseChildren(element);
      }
    });
  });

  _defineProperty(this, "groupCodeBlocks", function () {
    _this.content.blocks = _this.content.blocks.reduce(function (acc, block) {
      var blocks = acc.slice(0, -1);
      var lastBlock = acc.slice(-1)[0];

      if (block.type === 'code-block' && lastBlock != null && lastBlock.type === 'code-block') {
        return _toConsumableArray(blocks).concat([_objectSpread({}, lastBlock, {
          text: lastBlock.text + '\n' + block.text
        })]);
      } else {
        return _toConsumableArray(acc).concat([block]);
      }
    }, []);
  });

  _defineProperty(this, "convert", function (html) {
    _this.content = _this.defaultContent;
    var node = getSafeBodyFromHTML(html);

    _this.traverseChildren(node);

    _this.groupCodeBlocks();

    return _this.content;
  });

  this.entityKey = 0;
  this.offset = 0;

  if (options && options.parseBlock != null) {
    this.customParseBlock = options.parseBlock;
  }

  if (options && options.parseTextFragment != null) {
    this.customParseTextFragment = options.parseTextFragment;
  }

  this.content = this.defaultContent = {
    blocks: [{
      text: ''
    }],
    entityMap: {}
  };
};

var convertFromHTML = function convertFromHTML(html, options) {
  var contentState = new RawDraftContent(options);
  return contentState.convert(html);
};

export default convertFromHTML;
//# sourceMappingURL=index.es.js.map
